import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";

export const useGetUnmatchedIngredients = (
    queryKey: string | (string | number)[],
    parameters: { page: number; limit: number },
    options?: { enabled?: boolean; keepPreviousData?: boolean },
): UseQueryResult<types.IOffsetPage<types.IUnmatchedIngredientName>> => {
    const auth = useAuth();

    return useQuery<types.IOffsetPage<types.IUnmatchedIngredientName>>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch without authorization token.");
            }
            return await api.Ingredients.listUnmatched(parameters, auth.token);
        },
        options,
    );
};
